var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"steps"},_vm._l((_vm.steps),function(item){return _c('li',{key:item.step,staticClass:"step",class:[
      { 'is-complete': item.step < _vm.currentStep },
      { 'is-active': item.step === _vm.currentStep }
    ],attrs:{"data-step":item.step + 1}},[(item.text)?_c('div',{staticClass:"step-text"},[_vm._v(_vm._s(item.text))]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }